import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { TextQuestion as TextQuestionType } from "./questionTypes";

interface TextQuestionProps {
  question: TextQuestionType;
  value: string;
  onChange: (questionId: string, value: string) => void;
}

export function TextQuestion({ question, value, onChange }: TextQuestionProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <h2 className="text-xl font-semibold">
          {question.title}
        </h2>
      </div>
      
      <Input
        id={question.id}
        type="text"
        placeholder={question.placeholder}
        value={value || ""}
        onChange={(e) => onChange(question.id, e.target.value)}
        maxLength={question.maxLength}
        className="w-full text-lg py-4 px-6 min-h-[60px]"
      />
    </div>
  );
}